<div class="wa-table-details">
  <table class="wa-table-inner">
    <tbody class="wa-table-inner__row-group">
      <tr class="wa-table-inner__row" *ngFor="let detail of details">
        <td class="wa-table-inner__cell wa-table-inner__cell--order-0 wa-table-inner__cell--wide">
          <div class="event">
            <a [href]="lang+'competition/'+detail.ID.toString()" class="event__name">        {{ detail.NameShort !== '' && detail.NameShort ? detail.NameShort : detail.Name }} </a>
            <div class="event__img">
              <img [lazyLoad]="
                    '//extranet.worldarchery.sport/Flags/' +
                    detail.Country +
                    '.svg'
                  " />
            </div>
          </div>
        </td>
        <td class="wa-table-inner__cell wa-table-inner__cell--right wa-table-inner__cell--order-2 wa-table-inner__cell--wide">
          <div class="date">
            {{ detail.Date | date: "d MMMM yyyy" | uppercase }}
          </div>
        </td>
        <td class="wa-table-inner__cell wa-table-inner__cell--order-3 wa-table-inner__cell--narrow">
          <div class="score score--small" [ngClass]="detail.Points? 'highlight' : ''">
            {{ detail.Points }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
